import(/* webpackMode: "eager" */ "/Users/andersandersson/dev/presentgatan.se/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/Users/andersandersson/dev/presentgatan.se/src/app/components/Footer/footer.module.scss");
;
import(/* webpackMode: "eager" */ "/Users/andersandersson/dev/presentgatan.se/src/app/components/ProductPageGallery/product-page.module.scss");
;
import(/* webpackMode: "eager" */ "/Users/andersandersson/dev/presentgatan.se/src/app/(pages)/blogg/[slug]/blogg-pages.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/andersandersson/dev/presentgatan.se/src/app/components/Underline/underline.js");
